var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8IdentificationDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 11.05,
    viewBox: "0 0 12.25 11.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-identification-documents",
    d: "M9,4A1.716,1.716,0,0,0,7.286,5.705v.568h-3A1.289,1.289,0,0,0,3,7.553v5.968A1.289,1.289,0,0,0,4.286,14.8h9.429A1.289,1.289,0,0,0,15,13.521V7.553a1.289,1.289,0,0,0-1.286-1.279h-3V5.705A1.716,1.716,0,0,0,9,4Zm0,.853a.849.849,0,0,1,.857.853V6.984a.136.136,0,0,1-.143.142H8.286a.136.136,0,0,1-.143-.142V5.705A.849.849,0,0,1,9,4.853ZM4.286,7.126H7.3a1,1,0,0,0,.985.853H9.714a1,1,0,0,0,.985-.853h3.015a.421.421,0,0,1,.429.426v5.968a.421.421,0,0,1-.429.426H4.286a.421.421,0,0,1-.429-.426V7.553A.421.421,0,0,1,4.286,7.126ZM6.429,8.832a.853.853,0,1,0,.857.853A.855.855,0,0,0,6.429,8.832ZM9.714,9.4a.426.426,0,1,0,0,.853h2.857a.426.426,0,1,0,0-.853ZM5.429,11.105A.428.428,0,0,0,5,11.532c0,.426,0,1.279,1.4,1.279h.057c1.4,0,1.4-.853,1.4-1.279a.428.428,0,0,0-.429-.426Zm4.286.284a.426.426,0,1,0,0,.853h2.857a.426.426,0,1,0,0-.853Z",
    transform: "translate(-2.875 -3.875)",
    fill: "#2A60BC",
    stroke: "#2A60BC",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8IdentificationDocuments);
export default __webpack_public_path__ + "static/media/icons8-identification-documents.9bccd7b0212323b2562eb8f0ced9b44d.svg";
export { ForwardRef as ReactComponent };